// extracted by mini-css-extract-plugin
var _1 = "Resizer_resizer__57fd1";
var _2 = "Resizer_resizing__c308a";
export { _1 as "resizer", _2 as "resizing" }
